import { defaultTo, includes, keys } from 'ramda';

import { toIsoDateFormat } from 'utils';

import { beDateKeys, beDateLikeFieldsKeys, feToBeMap, numericFields } from './constants';

export const bodyFactory = (formData) => {
	// separating checkbox values and rest of the formData
	const { gcpContractsOnly, gpContractsOnly, frameworkPolicyOnly, activePolicyWoQuotationOnly, ...restFormData } =
		formData;

	// default bodyFactory
	const body = keys(restFormData).reduce((acc, key) => {
		const beKey = defaultTo(key, feToBeMap[key]);
		// sellerIn number wrap in array
		if (beKey === 'sellerIns') {
			acc.sellerIns = [formData.policyHolderNumber];
		} else if (includes(beKey, numericFields)) {
			// convert to number types
			acc[beKey] = +formData[key];
		} else if (includes(beKey, beDateKeys)) {
			// convert to iso dates
			acc[beKey] = toIsoDateFormat(formData[key]);
		} else if (includes(beKey, beDateLikeFieldsKeys)) {
			// remove dots and forward slash from date like values
			acc[beKey] = processDateLikeField(formData[key]);
		} else if (beKey === 'lastCommunicationAgeId') {
			acc[beKey] = +formData[key];
		} else {
			acc[beKey] = formData[key];
		}
		return acc;
	}, {});

	const generateCompanyId = (gcpContractsOnly, gpContractsOnly) => {
		if (gcpContractsOnly && gpContractsOnly) {
			// body without companyId
			return false;
		} else if (gpContractsOnly) {
			return {
				companyId: 8,
			};
		} else if (gcpContractsOnly) {
			return {
				companyId: 1,
			};
		}
	};

	return {
		...body,
		...generateCompanyId(gcpContractsOnly, gpContractsOnly),
		frameworkPolicyOnly: frameworkPolicyOnly ?? false,
		activePolicyWoQuotationOnly: activePolicyWoQuotationOnly ?? false,
	};
};

const processDateLikeField = (dateLikeValue) => {
	const slashOrDot = new RegExp(/[\/.]/);
	if (slashOrDot.test(dateLikeValue)) {
		// DD/MM or DD.MM formats
		const splitted = dateLikeValue.split(slashOrDot);
		return splitted.reverse().join('');
	} else {
		// DDMM format
		const splitted = dateLikeValue.match(/.{1,2}/g);
		return splitted.reverse().join('');
	}
};
